import React from 'react';
import { useLocation } from 'react-router-dom';

import { matchAnyReportingInternalRenderReportUrl } from '@futrli/shared-services';

import { AppAuth } from './app-auth';
import { AppRenderReport } from './app-render-report';
import { AppRenderWidget, AppRenderWidgetProps } from './app-render-widget';

interface Props {
  widgetMode?: AppRenderWidgetProps;
}

export const App = ({ widgetMode }: Props) => {
  const { pathname } = useLocation();

  if (widgetMode) {
    return <AppRenderWidget {...widgetMode} />;
  }
  if (matchAnyReportingInternalRenderReportUrl(pathname)) {
    return <AppRenderReport />;
  }

  return <AppAuth />;
};
